import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { withContext, combineEventHandlers, eventBus } from '@piggybank/core';
import { Formik } from 'formik';
import FormikForm from './FormikForm.js';
import { Consumer } from '../Wizard/context.js';

var Form = function Form(_ref) {
  var _ref$enableReinitiali = _ref.enableReinitialize,
      enableReinitialize = _ref$enableReinitiali === void 0 ? true : _ref$enableReinitiali,
      isInitialValid = _ref.isInitialValid,
      initialValues = _ref.initialValues,
      onReset = _ref.onReset,
      _ref$onSubmit = _ref.onSubmit,
      _onSubmit = _ref$onSubmit === void 0 ? function () {} : _ref$onSubmit,
      _ref$setInitialValues = _ref.setInitialValues,
      setInitialValues = _ref$setInitialValues === void 0 ? function (initialValues) {
    return initialValues;
  } : _ref$setInitialValues,
      validate = _ref.validate,
      validateOnBlur = _ref.validateOnBlur,
      validateOnChange = _ref.validateOnChange,
      validationSchema = _ref.validationSchema,
      _ref$debounceWait = _ref.debounceWait,
      debounceWait = _ref$debounceWait === void 0 ? 250 : _ref$debounceWait,
      _ref$textMap = _ref.textMap,
      textMap = _ref$textMap === void 0 ? {
    errorAnnouncementPrefix: 'Error: '
  } : _ref$textMap,
      props = _objectWithoutProperties(_ref, ["enableReinitialize", "isInitialValid", "initialValues", "onReset", "onSubmit", "setInitialValues", "validate", "validateOnBlur", "validateOnChange", "validationSchema", "debounceWait", "textMap"]);

  return React.createElement(Formik, {
    enableReinitialize: enableReinitialize,
    isInitialValid: isInitialValid,
    initialValues: setInitialValues(initialValues),
    initialStatus: {
      debounceWait: debounceWait
    },
    onReset: onReset,
    onSubmit: function onSubmit(values, formikBag) {
      try {
        formikBag.setSubmitting(true);
        return Promise.resolve(_onSubmit({
          values: values,
          formikBag: formikBag
        })).then(function () {
          formikBag.setSubmitting(false);
          eventBus.dispatch({
            type: 'onSubmit',
            component: 'Form',
            values: values
          });
        });
      } catch (e) {
        return Promise.reject(e);
      }
    },
    validate: validate,
    validateOnBlur: validateOnBlur,
    validateOnChange: validateOnChange,
    validationSchema: validationSchema
  }, function (formikProps) {
    return React.createElement(FormikForm, _extends({
      formik: formikProps,
      textMap: textMap
    }, props));
  });
};

Form.displayName = 'Form';
Form.propTypes = process.env.NODE_ENV !== "production" ? {
  enableReinitialize: PropTypes.bool,
  isInitialValid: PropTypes.bool,
  initialValues: PropTypes.object.isRequired,
  onReset: PropTypes.func,

  /** docgen-from-context:<Wizard/> */
  onSubmit: PropTypes.func,
  validate: PropTypes.func,
  validateOnBlur: PropTypes.bool,
  validateOnChange: PropTypes.bool,
  validationSchema: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  textMap: PropTypes.shape({
    errorAnnouncementPrefix: PropTypes.string
  }),

  /** docgen-from-context:<Wizard/> */
  setInitialValues: PropTypes.func,

  /** docgen-from-context:<Wizard/> */
  debouncedOnChange: PropTypes.func,
  onError: PropTypes.func,
  debounceWait: PropTypes.number
} : {};
var Form$1 = withContext(Consumer, function (value, ownProps) {
  return {
    onSubmit: combineEventHandlers(ownProps.onSubmit, value.onSubmit),
    setInitialValues: value.setInitialValues,
    debouncedOnChange: value.setUnsubmittedValues
  };
})(Form);
export default Form$1;
export { Form };